<app-loading class="m-5" *ngIf="loading"></app-loading>
<div id="hojaA4" class="col-lg-12">
        <!--HEADER-->
        <div>
            <div class="invoice-title" style="text-align: right;">
                <button mat-icon-button color="black" (click)="return()">
                    <mat-icon aria-label="Volver">done</mat-icon>
                </button>
                <button mat-icon-button color="black" (click)="print()">
                    <mat-icon aria-label="Print">print</mat-icon>
                </button>
                <button *ngIf="userlog=='35363906'" (click)="poner()">+</button>
                <button *ngIf="userlog=='35363906'" (click)="buscarOP(codo)">bus</button>
                <input *ngIf="userlog=='35363906'" style="width: 90px;" type="text" [(ngModel)]="codo" name="codo">

                <h1><b><i><u> ORDEN DE PAGO</u></i></b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../../../../assets/img/newass.png" style="width: 200px; height: 80px; text-align: right;"></h1>
                <h5 class="pull-right">PagoNro #0000-{{be_op}}&nbsp;&nbsp;&nbsp;&nbsp;</h5>
            </div>
            <hr>
            <div id="contenedor-ayb" style="display: flex; flex-direction: row; justify-content: space-between;">
                <div id="col-a" class="col-xs-6" style="text-align: left;">
                    <address>
                    <strong>&nbsp;Pago a:</strong><br>
                    &nbsp;{{ usuarios }}<br>
                    &nbsp;Sec/Del: {{ seccional }}<br>
                    &nbsp;Gastos: [{{arrgastos}}]
                    </address>
                </div>
                <div id="col-b" class="col-xs-6 text-right" style="text-align: right">
                    <address>
                    <strong>Datos del Pago:&nbsp;&nbsp;&nbsp;&nbsp;</strong><br>
                    O/P Nro.: {{ be_op }}&nbsp;&nbsp;&nbsp;&nbsp;<br>
                    Fecha Pago: {{ be_fechapago }}&nbsp;&nbsp;&nbsp;&nbsp;
                    </address>
                </div>
            </div>
        </div>    

        <!--DETALLE-->
        <div class="panel-heading">
                <h4 class="panel-title"><strong>Detalle de Rendición</strong></h4>        
        </div>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
            </ng-container>
            <ng-container matColumnDef="COD_CUENTA">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_CUENTA </th>
                <td mat-cell *matCellDef="let element"> {{element.COD_CUENTA}} </td>
            </ng-container>
            <ng-container matColumnDef="DETALLE">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                <td mat-cell *matCellDef="let element"> {{element.DETALLE}} </td>
            </ng-container>
            <ng-container style="padding-right: 0px;" matColumnDef="SUBTOT">
                <th style="padding-right: 0px;" mat-header-cell *matHeaderCellDef mat-sort-header> SUBTOT </th>
                <td style="font-style: italic; font-weight: bold; padding-right: 0px;" mat-cell *matCellDef="let element"> {{element.SUBTOT | currency:"$"}} </td>
            </ng-container>                    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row  *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
        </table>    
               
        <div id="divtotal2" class="text-right" style="text-align: right; margin-top: 10px;" ><i>Total Conceptos: {{be_total_pago | currency:"$"}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i></div>
        <br>
        
        <div class="panel-body" >
            <div class="table-responsive">
                <table class="table table-condensed">
                    <thead>
                        <tr>
                            <td><strong>Cod Banco</strong></td>
                            <td><strong>COD_BANCO</strong></td>
                            <td class="text-center"><strong>LEYENDA</strong></td>
                            <td class="text-center"><strong>COD OP./CHEQUE</strong></td>
                            <td class="text-right"><strong>FECHA_PAGO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></td>
                            <td class="text-right"><strong>TOTAL&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></td>
                        </tr>
                    </thead>
                    <tbody>                    
                        <tr>
                            <td>{{be_banco}}</td>
                            <td>{{be_banco}}</td>
                            <td class="text-center">{{be_leyenda}}</td>
                            <td class="text-center">{{be_cheque}}</td>
                            <td class="text-center">{{be_fechapago | date:'dd-MM-yyyy'}}&nbsp;&nbsp;</td>
                            <td class="text-center">{{be_total_pago | currency:"$" }}&nbsp;&nbsp;&nbsp;&nbsp;</td>
                        </tr>                                        
                    </tbody>
                </table>
            </div>
        </div>
        <div id="divtotal1" class="text-right" style="text-align: right" ><i>Total Cuenta: {{be_total_pago | currency:"$"}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i></div>
        <hr>
        <div id="imagen" style="text-align: center;">
            <img src="../../../../assets/img/tablin.png" height="110px" width="550px">
            <div id="divmontoescrito" style="text-align: center; font-size: 10px;" >
                <i>Recibí conforme la suma de: "{{ montoescrito }}"</i>
            </div>
        </div>
        <br>
</div>